import {
  chakraComponents,
  GroupBase,
  SingleValueProps,
} from 'chakra-react-select';
import { Option } from 'types/general.types';

export const SingleValue = ({
  children,
  ...props
}: SingleValueProps<Option, false, GroupBase<Option>>) => (
  <chakraComponents.SingleValue
    {...props}
    innerProps={
      {
        'data-testid': 'selected-value',
      } as SingleValueProps['innerProps']
    }
  >
    {children}
  </chakraComponents.SingleValue>
);
